import React from 'react'
import { useSelector } from 'react-redux'
import { MY_SERVICES_STAGE_KEYS } from 'app-constants'
import { MyServices, IntegrationError } from './components'

export function MyServicesDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages()[stage]
}

function stages() {
  return {
    [MY_SERVICES_STAGE_KEYS.INITIAL]: <MyServices />,
    [MY_SERVICES_STAGE_KEYS.ERROR]: <IntegrationError />,
  }
}
